import axios from "axios";
import Filters from "@/config/filters.js";

class Store {
  constructor() {
    this.state = {
      alloys: [],
      alloysBackup: [],
      selectedFilters: {},
      filtersList: JSON.parse(JSON.stringify(Filters)),
      productUniverses: [],
      allUniversSelected: true,
      formsAndSizesSelected: [],
      allFormsAndSizesSelected: true,
      userIsLoggedIn: false,
      username: "",
      user: {},
      selectedSortProperty: "yieldStrengthMPa",
    };
  }
  /**
   * Fonction créée afin d'initialiser formsAndSizesSelected
   * Ce tableau est utilisé par les checkbox du group Forms and Sizes
   * Toutes sont cochées au départ. Les filtres vont aller itérer sur formsAndSizesSelected
   * Afin de voir quels alliages récupérer.
   */
  initFormsAndSizes() {
    this.state.formsAndSizesSelected = this.state.filtersList[
      "Forms and sizes"
    ].datas.map((f) => f.technicalId);
  }

  /**
   * Récupère le clic sur l'alliage depuis les suggestions
   * Et affiche cet alliage uniquement
   */
  searchByKeyword(alloySelected) {
    this.state.alloys = this.state.alloysBackup.filter(
      (alloy) => alloy === alloySelected
    );
  }

  /**
   * Fonction parcourant la liste des alliages et la liste des filtres,
   * permettant de retourner les alliages filtrés
   */
  filterAlloysItems() {
    let filters = this.state.selectedFilters;
    this.state.alloys = this.state.alloysBackup.filter((alloy) => {
      for (let key in filters) {
        // Si le filtre est un slider, on vérifie que la valeur soit située dans les bornes de celles du filtres
        if (filters[key].type === "slider") {
          let alloyValue = null;
          if (alloy[key] && alloy[key].includes("-")) {
            alloyValue = alloy[key].split("-")[1];
          } else if (alloy[key]) {
            alloyValue = alloy[key];
          }
          if (
            alloyValue &&
            parseFloat(alloyValue) <= parseFloat(filters[key].value)
          ) {
            return false;
          }
        }

        // Si le filtre est un champ texte, on vérifie que le champ de l'alliage contienne le texte saisi dans le filtre
        else if (filters[key].type === "text") {
          if (
            alloy[key] === undefined ||
            !alloy[key].toLowerCase().includes(filters[key].value.toLowerCase())
          ) {
            return false;
          }
        }

        // Si le filtre est un select, on vérifie que la valeur de l'alliage soit égale à la valeur du select
        else if (filters[key].type === "select") {
          if (filters[key].value.length != 0 && alloy[key] != undefined) {
            let match = false;
            for (let val of filters[key].value) {
              if (
                Number.isInteger(val) &&
                parseInt(alloy[key]) === parseInt(val)
              ) {
                match = true;
              }
            }
            if (!match) return false;
          }
        }

        // Si on utilise la recherche globale
        else if (filters[key].type === "globalSearch") {
          let includeText;
          const searchTerm = filters[key].value.toLowerCase();
          // Pour chaque champ de l'alliage
          for (let field in alloy) {
            includeText = false;
            // Si la valeur du champ n'est pas indéfinie, n'est pas un nombre et n'est pas un tableau de universes
            if (
              alloy[field] != undefined &&
              isNaN(alloy[field]) &&
              field != "productUniverse"
            ) {
              // Si le champ est un tableau, on parcourt chaque valeur pour voir s'il y a une correspondance avec le terme recherché
              if (Array.isArray(alloy[field])) {
                for (let item of alloy[field]) {
                  const itemFormatted = item.toLowerCase();
                  if (itemFormatted.includes(searchTerm)) {
                    includeText = true;
                  }
                }
              } else if (alloy[field].toLowerCase().includes(searchTerm)) {
                includeText = true;
              }
            }
            // On arrête la boucle sur les champs d'alliage courant
            if (includeText) break;
          }
          // Si aucun champ n'inclu le terme recherché, on ne renvoie pas l'alliage en question
          if (!includeText) return false;
        }
      }

      // Filtres sur les univers présents dans le tableau productUniverses
      let alloyMatch = false;
      for (let item of alloy["productUniverse"]) {
        if (this.state.productUniverses.includes(item.display)) {
          alloyMatch = true;
        }
      }

      // Filtres sur les univers présents dans le tableau formsAndSizesSelected
      let formsSizesMatch = false;
      for (let formsSizesName of this.state.formsAndSizesSelected) {
        if (alloy[formsSizesName] === true) {
          formsSizesMatch = true;
        }
      }

      /**
       * S'il n'y a aucun form ou size présent dans formsAndSizesSelected
       * qui est à True pour l'alliage courant
       */
      if (!formsSizesMatch) {
        alloyMatch = false;
      }

      return alloyMatch;
    });
  }
  /**
   * Réinitialisation des filtres
   */
  resetFilters(universesList) {
    // Remise à zéro des filtres sélectionnés
    this.state.selectedFilters = {};
    // Réinitialisation de l'état des filtres
    this.state.filtersList = JSON.parse(JSON.stringify(Filters));
    // Réinitialisation du filtre Univers
    this.state.productUniverses = universesList.map((u) => u.universName);
    this.state.allUniversSelected = true;
    // Réinitialisation du filtre Forms and Sizes
    this.initFormsAndSizes();
    this.state.allFormsAndSizesSelected = true;
    // On remet la valeur du tri par défaut
    this.state.selectedSortProperty = "yieldStrengthMPa";
    // On relance la méthode filtre pour faire apparaître tous les alliages
    this.filterAlloysItems();
    this.changeUniverse("all", universesList);
  }
  /**
   * Supprime un filtre précis, en lui passant sa clef en paramètre
   * (identifiant technique présent en base)
   */
  deleteFilter(key) {
    delete this.state.selectedFilters[key];
  }
  /**
   * Changement de l'objet contenant les filtres actif
   * @param {*} property Nom de la propriété sur lequel le filtre sera actif
   * @param {*} type Type de filtre ("checkbox", "slider", ou "text")
   * @param {*} value Valeur
   */
  addFilter(property, type, value) {
    /* Si la valeur est "false", on efface la propriété
      Ex: si on souhaite tous les alliages qui ont la propriété "Rods" à "true",
      on coche la checkbox et on récupère tous les alliages qui ont cette propriété à "true".
      Par contre, si on décoche la checkbox, celle-ci nous renvoie false. Or, nous ne souhaitons pas
      récupérer tous les alliages qui ont la propriété "Rods" à "false", mais celles qui sont à "true" OU "false".
      On retire donc le filtre afin de tout récupérer.
    */
    if (value === false || value === "" || value === "all") {
      delete this.state.selectedFilters[property];
    } else {
      this.state.selectedFilters[property] = { type, value };
    }
    this.filterAlloysItems();
    this.sortAlloysItems();
  }
  changeFormsAndSizes(formsAndSizeName) {
    if (formsAndSizeName === "all") {
      // Si la checkbox All est cochée, on active tous les forms and sizes
      if (this.state.allFormsAndSizesSelected) {
        this.state.formsAndSizesSelected = this.state.filtersList[
          "Forms and sizes"
        ].datas.map((f) => f.technicalId);
      } else {
        // Si la checkbox All est décochée, on décoche tous les forms and sizes
        this.state.formsAndSizesSelected = [];
      }
    } else {
      // Si on coche autre chose que All
      this.state.allFormsAndSizesSelected = false;
    }
    this.filterAlloysItems();
    this.sortAlloysItems();
  }
  changeUniverse(universName, universesList) {
    /**
     * Si universName est "all", on coche toutes les checkbox
     */
    if (universName === "all") {
      // Si la checkbox All est cochée, on active tous les univers
      if (this.state.allUniversSelected) {
        this.state.productUniverses = universesList.map((u) => u.universName);
      } else {
        // Si la checkbox All est décochée, on décoche tous les univers
        this.state.productUniverses = [];
      }
    } else {
      // Si on coche autre chose que All
      this.state.allUniversSelected = false;
    }
    /**
     * La fonction filterAlloysItems() filtres les alliages en fonction des univers présents
     * dans le tableau productUniverses lié aux checkbox par un v-model
     */
    this.filterAlloysItems();
    this.sortAlloysItems();
  }
  sortAlloysItems(param) {
    const property = param || this.state.selectedSortProperty;
    if (param) this.state.selectedSortProperty = param;
    const factor = property == "brandName" ? 1 : -1;
    this.state.alloys.sort((a, b) => {
      // Si c'est une chaîne de caractères
      if (isNaN(parseFloat(a[property])) || isNaN(parseFloat(b[property]))) {
        if (a[property] === "" || a === null) return factor * -1;
        if (b[property] === "" || b === null) return 1 * factor;
        return a[property] > b[property] ? 1 * factor : -1 * factor;
      }
      // Si c'est un nombre
      else {
        let aValue, bValue;

        // On vérifie que la valeur de a est un interval
        // Si oui on prends la borne supérieur
        if (a[property] && a[property].includes("-")) {
          aValue = a[property].split("-")[1];
        } else {
          aValue = a[property];
        }
        // On vérifie que la valeur de b est un interval
        // Si oui on prends la borne supérieur
        if (b[property] && b[property].includes("-")) {
          bValue = b[property].split("-")[1];
        } else {
          bValue = b[property];
        }

        return (
          factor *
          (parseFloat(aValue.replace(",", ".")) -
            parseFloat(bValue.replace(",", ".")))
        );
      }
    });
  }

  formatDateWithZero(dateItem) {
    return dateItem < 10 ? "0" + dateItem : dateItem;
  }

  userLogin(user) {
    const username = user.data.name;
    this.state.username = user.data.name;
    this.state.user = user.data;
    this.state.token = user.data.api_key;
    this.state.userIsLoggedIn = true;
    const date = new Date();
    const year = date.getFullYear();
    const month = this.formatDateWithZero(date.getMonth() + 1);
    const day = this.formatDateWithZero(date.getDate());
    const hours = this.formatDateWithZero(date.getHours());
    const minutes = this.formatDateWithZero(date.getMinutes());

    axios({
      method: "post",
      url: "collections/save/user_logs?token=" + user.data.api_key,
      headers: { "Content-Type": "application/json" },
      data: JSON.stringify({
        data: {
          user: username,
          date: year + "-" + month + "-" + day,
          time: hours + ":" + minutes,
        },
      }),
    });
  }

  userLogOut() {
    this.state.token = null;
    this.state.userIsLoggedIn = false;
  }

  userIsLoggedIn() {
    return this.state.userIsLoggedIn;
  }
}

export default new Store();
